import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as classesActions from 'Store/classes/actions';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

import styles from './ClassEnabledModels.scss';
import ParagraphSubheaderWithIcon from 'Components/ParagraphSubheaderWithIcon';
import EditEnabledModulesLightbox from 'Components/EditEnabledModulesForm/EditEnabledModulesLightbox';
import { appData } from 'Settings';

const ClassEnabledModels = (props) => {
  const {
    disabledModules,
    classId,
    schoolId,
    postClassDisabledModules,
  } = props;

  const enabledModulesList = appData.filter(
    ({ slug }) => !(disabledModules || []).includes(slug)
  );

  return (
    <div className="ClassEnabledModels">
      <div className="ClassEnabledModels__container">
        <div className="ClassEnabledModels__container__title">
          <div style={{ flex: 1 }}>
            <ParagraphSubheaderWithIcon
              text={
                disabledModules && disabledModules.length > 0 ? (
                  <ConnectedFormattedMessage
                    id="class_page_enabled_models.some_models_enabled"
                    values={{
                      model_count: `${10 - disabledModules.length} / ${
                        appData.length
                      }`,
                    }}
                  />
                ) : (
                  <ConnectedFormattedMessage id="class_page_enabled_models.all_models_enabled" />
                )
              }
              type="teacher"
            />
          </div>
          <div>
            <EditEnabledModulesLightbox
              disabledModules={disabledModules}
              onSubmit={(disabledModules) => {
                postClassDisabledModules(schoolId, classId, disabledModules);
              }}
            />
          </div>
        </div>
        <div className="ClassEnabledModels__container__tags">
          {enabledModulesList.map((item) => (
            <div
              className={`ClassEnabledModels__tag ClassEnabledModels__tag--${item.slug} `}
            >
              {item.title}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

ClassEnabledModels.propTypes = {
  disabledModules: PropTypes.array.isRequired,
  classId: PropTypes.object.isRequired,
  schoolId: PropTypes.object.isRequired,
  postClassDisabledModules: PropTypes.func.isRequired,
};

export default connect(() => {}, classesActions)(ClassEnabledModels);
